import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import useGlobalContext from "../../hooks/useGlobalContext";
import FormDataPage from "./RequestDemo";
import { Modal } from "react-bootstrap";
import { BASE_URL } from "../../constants";

const Header = () => {
  const [form, setForm] = useState(false);
  const [dsiderAi, setDsiderAi] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { stickyMenu } = useGlobalContext();
  const { pathname } = useLocation();

  return (
    <>
      <Modal
        show={form}
        keyboard={false}
        backdrop="static"
        onHide={() => {
          setForm(false);
        }}
        centered
        className="modelDsider"
      >
        <Modal.Header closeButton>
          <Modal.Title>Please fill the form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormDataPage setForm={setForm} />
        </Modal.Body>
        <Modal.Footer>
          {/* <Link to="/" className="z-btn z-btn-3" onClick={handleClose}>Ok, Got It</Link> */}
        </Modal.Footer>
      </Modal>

      <Link
        to="/link"
        id="IamDiderAI"
        className="z-btn d-none z-btn-3"
        onClick={(e) => {
          e.preventDefault();
          setDsiderAi(true);
        }}
      >
        Get in Touch
      </Link>

      <Modal
        size="xl"
        show={dsiderAi}
        keyboard={true}
        onHide={() => {
          setDsiderAi(false);
        }}
        centered
        className="modelDsider"
        style={{ background: "transparent" }}
      >
        <Modal.Body>
          <img src="/dsiderAi.png" alt="Dsider AI" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>
      <header>
        <div>
          <div
            id="header__sticky"
            className={
              stickyMenu
                ? "sticky header__bottom header__bottom-2"
                : "header__bottom header__bottom-2"
            }
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-1 col-6">
                  <div className="logo-3 m-img">
                    <Link to="/">
                      <img
                        src={`${BASE_URL}logos/header_logo.png`}
                        alt="Dsider"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-9 col-3">
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="main-menu">
                      <nav id="mobile-menu">
                        <ul>
                          <li>
                            <NavLink
                              to="/"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Home
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/industries"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Industries
                            </NavLink>
                          </li>

                          {/* technology */}
                          <li>
                            <NavLink
                              to="/technology"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Technology
                            </NavLink>
                          </li>

                          {/* Products.... */}
                          <li className="dropdown">
                            <span
                              className={
                                (pathname.startsWith("/products") || pathname === "/midstream")
                                  ? "active-link"
                                  : ""
                              }
                            >
                              Products
                            </span>
                            <ul className="dropdown-menu">
                              <li><span aria-disabled="true" style={{ color: "#aaa", cursor: "not-allowed" }}>Upstream</span></li>
                              <li><Link to="/midstream">Midstream</Link></li>
                              <li><span aria-disabled="true" style={{ color: "#aaa", cursor: "not-allowed" }}>CleanTech</span></li>
                            </ul>
                          </li>
                          <li>
                            <NavLink
                              to="/offerings"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Offerings
                            </NavLink>
                          </li>
                          {/* <li>
                            <NavLink
                              to="/team"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            > */}
                              {/* Team */}
                              {/* Our Team
                            </NavLink>
                          </li> */}

                          <li className="dropdown">
                            Insights
                            <ul className="dropdown-menu">
                              <li><a href="/news">News</a></li>
                              <li><a href="/blogs">Blogs</a></li>
                            </ul>
                          </li>
                          <li>
                            <NavLink
                              to="/careers"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Careers
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              to="/contact"
                              className={({ isActive }) =>
                                isActive ? "active-link" : ""
                              }
                            >
                              Contact Us
                            </NavLink>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-3">
                  <div className="d-flex justify-content-end align-items-center">
                    <div className="d-none d-sm-block d-xl-block">
                      <Link
                        to="/link"
                        id="GetInTouchBtn"
                        className="z-btn z-btn-3"
                        onClick={(e) => {
                          e.preventDefault();
                          setForm(!form);
                        }}
                      >
                        Request Demo
                      </Link>
                    </div>
                    <div
                      onClick={handleShow}
                      className="sidebar__menu d-lg-none"
                    >
                      <div className="sidebar-toggle-btn" id="sidebar-toggle">
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <Sidebar show={show} handleClose={handleClose} />
    </>
  );
};

export default Header;
